const ravenMock = {
  captureException(e) {
    console.log(e);  // eslint-disable-line no-console
  },
};

const sentry = () => {
  if (!window.Sentry) {
    return ravenMock;
  }

  return window.Sentry;
};

export default sentry;



// WEBPACK FOOTER //
// ./src/app/utils/sentry.js